import { Component, Input, OnInit, Output, ViewChild } from '@angular/core';
import { HomeService } from '../home/home.services';
import { DataDirectoryService } from '../data-directory/data-directory.service';
import { ActivatedRoute } from '@angular/router';
import { BusinessCaseSettingComponent } from './business-case-setting/business-case-setting.component';

@Component({
  selector: 'app-user-own-setting',
  templateUrl: './user-own-setting.component.html',
  styleUrl: './user-own-setting.component.scss'
})
export class UserOwnSettingComponent implements OnInit {

  apiData: [];
  name = 'Next';
  enableRegTab = false;
  enableBeStudyTab = false;
  submolecules: any[];
  subMolecule = false;
  selectedSubMolecule: any;
  userModuleList = [];
  userSelectedModule: any;
  Molecule = false;
  searchValue = '';
  DragData: any = {};
  noData = false;
  apiCost: any;
  needRefresh: boolean; // to refresh child[investment-costig] api 
  clearData: boolean = true;
  paramsValues: any;

  constructor(private homeservice: HomeService, private directoryservice: DataDirectoryService, private route: ActivatedRoute,) {
    this.submolecules = [];
    this.directoryservice.serchKey = '';
  }

  @ViewChild('childComponent', { static: false })
  childComponent: any = BusinessCaseSettingComponent;
  anyMethod(): void {
    this.childComponent.getAllApis()
  }

  ngOnInit(): void {
    this.paramsValues = this.route.snapshot.queryParams;
    if (this.paramsValues.brand_name && this.paramsValues.nda && this.paramsValues.dosage) {
      this.searchValue = this.paramsValues.brand_name
      this.searchMolecule()
      // this.selectedSubMolecule = { code: 'WAKIX,211150,TABLET', name: 'WAKIX,211150,TABLET' }
      this.selectedSubMolecule = { code: (`${this.paramsValues.brand_name},${this.paramsValues.nda},${this.paramsValues.dosage}`), name: (`${this.paramsValues.brand_name},${this.paramsValues.nda},${this.paramsValues.dosage}`) }
      this.getData()
    }
    this.userListData()
  }

  clearFilter() {
    this.submolecules = [];
    this.selectedSubMolecule = {};
    this.Molecule = false;
    this.searchValue = '';
    this.subMolecule = false;
    this.clearData = false;
  }

  arrayToDropdown(InputArray) {
    let DropDownArray = [];
    InputArray.forEach((DropdownValues) => {
      let dropDownObj = {
        name: `${DropdownValues.brand_name},${DropdownValues.nda_number},${DropdownValues.dosage_forms}`,
        code: DropdownValues // store the full object for later use
      };
      DropDownArray.push(dropDownObj);
    });
    return DropDownArray;
  }

  searchMolecule() {
    if(this.userSelectedModule?.value){
      this.submolecules = [];
      this.homeservice.getNdaData(this.searchValue).subscribe((ndaValues) => {
        if (ndaValues['data'].nda_numbers.length >= 1) {
          let dropdownvalues = this.arrayToDropdown(ndaValues['data'].nda_numbers);
          this.submolecules = dropdownvalues;
          this.subMolecule = true;
          this.Molecule = false;
        } else {
          this.selectedSubMolecule = {};
          this.subMolecule = false;
          this.Molecule = false;
        }
      })
    }
    else{
      alert('Please select the user')
    }
  }

  getData() {
    if (this.selectedSubMolecule !== undefined) {
      let ndaValue = this.selectedSubMolecule['code'];
      this.needRefresh = false;
      this.homeservice.getDrugData(ndaValue).subscribe((MoleculeData: any) => {
        if (MoleculeData !== null) {
          this.apiCost = MoleculeData
          this.Molecule = true;
          this.DragData = MoleculeData;
          this.noData = false;
          this.needRefresh = true;
          this.clearData = true;

        } else {
          this.noData = true;
          this.Molecule = false;
          this.DragData = {};
        }
      })
    }
  }

  userListData(){
    this.homeservice.getUserList({
      "user_email": "websmithteam@gmail.com"
    }).subscribe((userList: any) => {
      console.log(userList);
      if(userList?.data?.length > 0){
        userList?.data.forEach((item: any) => {
          this.userModuleList.push({
            name: item,
            code: item,
            value: item,
            key: item
          })
        });
      }
    })
  }
  userSelectedModuleChange(){
    console.log(this.userSelectedModule);
  }
}
